import { render, staticRenderFns } from "./translated_multiselect.vue?vue&type=template&id=86c1c058"
import script from "./translated_multiselect.vue?vue&type=script&lang=js"
export * from "./translated_multiselect.vue?vue&type=script&lang=js"
import style0 from "./translated_multiselect.vue?vue&type=style&index=0&id=86c1c058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports